const productId = {
	product: {
		title: "Produk",
		subtitle: "Ringkasan daftar produk",
		filters: {
			store: "Toko",
			all_stores: "Semua Toko",
			type: "Tipe",
			all_types: "Semua Tipe",
			product: "Produk",
			ingredient: "Bahan Baku",
		},
		detail: {
			back: "Kembali",
			info_title: "Informasi Produk",
			name: "Nama Produk",
			category: "Kategori",
			type: "Tipe",
			description: "Deskripsi",
			online: "Dijual Online",
			yes: "Ya",
			no: "Tidak",
			not_found: "Produk tidak ditemukan.",
			tabs: {
				variant: "Varian",
				ingredient: "Bahan Baku",
				history: "Riwayat Supplier",
			},
		},
		variant: {
			title: "Varian Produk",
			add: "Tambah Varian",
			edit: "Ubah Varian",
			columns: {
				name: "Nama Varian",
				barcode: "Barcode",
				price: "Harga Jual",
				hpp: "HPP",
				stock: "Stok",
				unit: "Satuan",
				status: "Status",
				action: "Aksi",
			},
			fields: {
				store: "Toko",
				name: "Nama Varian",
				price: "Harga Jual",
				hpp: "HPP (Harga Pokok)",
				unit: "Satuan",
				precision: "Presisi Qty Order",
				stock: "Stok Awal",
				with_stock: "Kelola Stok",
				barcode: "Barcode",
				status: "Status",
				supplier: "Supplier",
				no_supplier: "Tanpa Supplier",
			},
			empty_state: {
				title: "Belum ada varian",
				description: "Tambahkan varian agar produk dapat dijual.",
			},
			add_success: "Varian berhasil dibuat",
			edit_success: "Varian berhasil diubah",
			delete_title: "Hapus Varian",
			delete_description:
				"Varian yang dihapus tidak dapat dikembalikan. Lanjutkan menghapus?",
			delete_success: "Varian berhasil dihapus",
			errors: {
				store_required: "Toko wajib dipilih",
				name_required: "Nama varian wajib diisi",
				price_min: "Nilai tidak boleh negatif",
			},
		},
		ingredient: {
			title: "Bahan Baku",
			add: "Tambah Resep",
			edit: "Ubah Resep",
			variant: "Varian",
			notes: "Catatan",
			items: "Komposisi",
			item_name: "Nama Bahan",
			item_qty: "Qty",
			item_unit: "Satuan",
			item_price: "Harga",
			add_item: "Tambah Bahan",
			remove_item: "Hapus",
			empty_state: {
				title: "Belum ada resep",
				description:
					"Tentukan bahan baku yang dipakai tiap varian saat produk terjual.",
			},
			add_success: "Resep berhasil disimpan",
			edit_success: "Resep berhasil diubah",
			delete_title: "Hapus Resep",
			delete_description: "Resep yang dihapus tidak dapat dikembalikan.",
			delete_success: "Resep berhasil dihapus",
		},
		history: {
			title: "Riwayat Stok Supplier",
			columns: {
				date: "Tanggal",
				supplier: "Supplier",
				variant: "Varian",
				type: "Tipe",
				qty: "Qty",
				price: "Harga",
				total: "Total",
			},
			empty_state: {
				title: "Belum ada riwayat",
				description: "Riwayat muncul setelah ada transaksi stok dari supplier.",
			},
		},
		common: {
			save: "Simpan",
			cancel: "Batal",
			delete: "Hapus",
		},
		table: {
			title: "Data Produk",
			columns: {
				name: "Nama Produk",
				category: "Kategori",
				type: "Tipe",
				variant_amonunt: { title: "Jumlah Varian", amount: "varian" },
				price: "Harga",
				stock: "Stok",
				status: "Status",
			},
		},
		forms: {
			import: {
				button: "Impor Data Produk",
				title: "Impor Data Produk",
				description: "Impor Data Produk",
			},
			export: {
				toast: {
					success: {
						title: "Berhasil",
						description: "Berhasil expor {rows} baris ke excell!",
					},
					failed: {
						title: "Failed",
						description: "Gagal expor data ke excell!",
					},
				},
			},
			edit: {
				title: "Edit Produk",
				description: "Edit Informasi Produk",
				info: "Informasi Produk",
				fields: {
					name: {
						label: "Nama Produk",
						placeholder: "Nama Produk",
					},
					category: {
						label: "Kategori",
						placeholder: "Kategori",
					},
					type: {
						label: "Tipe",
						placeholder: "Tipe",
					},
					store: {
						label: "Toko",
						placeholder: "Toko",
					},
					variant: {
						label: "Varian",
						placeholder: "Varian",
					},
					status: {
						label: "Status",
						placeholder: "Pilih Status",
					},
				},
				toast: {
					success: {
						title: "Berhasil",
						description: "Berhasil mengubah informasi produk!",
					},
					failed: {
						title: "Failed",
						description: "Gagal mengubah informasi produk!",
					},
				},
			},
			delete: {
				title: "Hapus Produk",
				description: "Apakah anda yakin akan menghapus {name}?",
				toast: {
					success: {
						title: "Berhasil",
						description: "Berhasil menghapus produk!",
					},
					failed: {
						title: "Failed",
						description: "Gagal menghapus produk!",
					},
				},
			},
		},
		empty_state: {
			title: "Tidak ada data produk",
			description: "Silakan tambahkan produk baru.",
		},
		actions: {
			save: "Simpan",
			save_changes: "Simpan Perubahan",
			saving_changes: "Menyimpan Perubahan...",
			saving: "Menyimpan...",
			delete: "Hapus",
			deleting: "Menghapus...",
			cancel: "Batal",
		},
		status: { active: "Aktif", inactive: "Non Aktif" },
	},
};

export default productId;
